export default {
  title: {
    en: 'High Scores',
    fr: 'Scores Élevés',
    it: 'Miglior Punteggio',
    nl: 'Hoge Scores'
  }
};
